"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMapPoligonCoordinatesFromUnknown = void 0;
const castNumberToCoordinate_1 = __importDefault(require("./castNumberToCoordinate"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const getNumberFromUnknownOrDefault_1 = __importDefault(require("./getNumberFromUnknownOrDefault"));
const valueIsControlsColorSpecification_1 = __importDefault(require("../typeAssertions/valueIsControlsColorSpecification"));
const getMapPoligonCoordinatesFromUnknown = (polygon) => {
    if (!(0, valueIsRecord_1.default)(polygon)) {
        return [];
    }
    let coordinates;
    if ((0, valueIsArray_1.default)(polygon.coordinates)) {
        coordinates = polygon.coordinates;
    }
    if ((0, valueIsRecord_1.default)(polygon.coordinates)) {
        coordinates = Object.values(polygon.coordinates);
    }
    return (coordinates || []).reduce((accumCoord, coord) => {
        if (!(0, valueIsRecord_1.default)(coord)) {
            return accumCoord;
        }
        const latitudeValue = (0, castNumberToCoordinate_1.default)(coord.latitude);
        const longitudeValue = (0, castNumberToCoordinate_1.default)(coord.longitude);
        if (latitudeValue && longitudeValue) {
            return [
                ...accumCoord,
                {
                    latitude: latitudeValue,
                    longitude: longitudeValue,
                },
            ];
        }
        return accumCoord;
    }, []);
};
exports.getMapPoligonCoordinatesFromUnknown = getMapPoligonCoordinatesFromUnknown;
const getMapPoligonsFromUnknown = ({ polygons, getColorFromSpecification, }) => {
    if (!(0, valueIsRecord_1.default)(polygons)) {
        return {};
    }
    return Object.entries(polygons).reduce((accumPolygon, [polygonId, polygon]) => {
        if (!(0, valueIsRecord_1.default)(polygon)) {
            return accumPolygon;
        }
        const coordinates = (0, exports.getMapPoligonCoordinatesFromUnknown)(polygon);
        if (!coordinates.length) {
            return accumPolygon;
        }
        const strokeWidth = (0, getNumberFromUnknownOrDefault_1.default)(polygon.strokeWidth, 2);
        const strokeColor = (0, valueIsControlsColorSpecification_1.default)(polygon.strokeColor)
            ? getColorFromSpecification(polygon.strokeColor)
            : undefined;
        const fillColor = (0, valueIsControlsColorSpecification_1.default)(polygon.fillColor)
            ? getColorFromSpecification(polygon.fillColor)
            : '#003892';
        return (Object.assign(Object.assign({}, accumPolygon), { [polygonId]: {
                coordinates,
                strokeWidth,
                strokeColor,
                fillColor,
            } }));
    }, {});
};
exports.default = getMapPoligonsFromUnknown;
